module.exports = __webpack_public_path__ + "static/media/im-cover-mob.1299ff22.jpg";